import { Input } from 'antd'
import { useLingui } from '@lingui/react/macro'


import { cls, tw } from 'tagged-classnames-free';
interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  className?: string
}

function SearchInput(props: SearchInputProps) {
  const { value, onChange, className = '' } = props
  const { t } = useLingui()

  return (
    <Input
      allowClear={{
        clearIcon: (
          <span
            className={cls`i-com--x text-f-text-quaternary hover:text-f-text size-4`}
          />
        ),
      }}
      prefix={
        <span className={cls`i-com--search text-f-text-quaternary size-4`} />
      }
      placeholder={t`Search for your favorite style`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={tw`h-8 w-64 shrink-0 rounded-[6px] bg-transparent ${className}`}
    />
  )
}

export default SearchInput
